import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../utils/Axios";

export const getDealFromId = createAsyncThunk<any, string | number>(
  "deal/getDealById",
  async dealId => {
    const response = await instance.get(`/deals/${dealId}/`);

    return response.data;
  }
);
